import { render, staticRenderFns } from "./SavedFiltersDropdown.vue?vue&type=template&id=116da80a&scoped=true&"
import script from "./SavedFiltersDropdown.vue?vue&type=script&lang=js&"
export * from "./SavedFiltersDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SavedFiltersDropdown.vue?vue&type=style&index=0&id=116da80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116da80a",
  null
  
)

export default component.exports